import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { correctClasses } from '../../common/config'
import wordSimilarity from '../../common/lib/wordSimilarity'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { TextInput, LessonMediaContent } from '../components'

class TranslationTest extends React.Component {
  componentDidMount() {
    const { lesson, initAnswers, showResult, practiceVocabularyLimit, vocabularyLimitSet } = this.props
    if (lesson && lesson.words && !showResult) {
      
      let lessonWords = lesson.words
      
      if (vocabularyLimitSet) {
        /* TODO random pick */
        lessonWords = lessonWords.slice(0, practiceVocabularyLimit)
      }
      
      const translationAnswers = lessonWords.map(word => ({
        baseWord: word.baseWord,
        userAnswer: '',
        correctAnswer: word.foreignWord,
        maxPoints: word.maxPoints,
      }))

      initAnswers(lesson.id, translationAnswers)
    }
  }

  checkAnswers() {
    const { lesson, setResult, answers } = this.props
    let points = 0
    answers.forEach(w => {
      const userAnswer = w.userAnswer.trim().toLowerCase()

      const similarities = w.correctAnswer.map(foreign =>
        wordSimilarity(foreign.toLowerCase(), userAnswer))
      
      const similarity = Math.max(...similarities)

      w.points = Math.round(similarity * w.maxPoints * 100) / 100
      if (w.points === w.maxPoints) {
        w.correct = 2
      } else if (!w.points) {
        w.correct = 0
      } else {
        w.correct = 1
      }
      points += w.points
    })
    setResult({ id: lesson.id, answers, points })
  }

  render() {
    const { lesson, updateAnswers, showResult, updateCursorIndex, intl,
      inputFocusHandler, answers, points, maxPoints, lessonOrder } = this.props

    if (!answers || !answers.length) return null

    return (
      <div className="translation-item">
        <p className="instructions">
          {lessonOrder}. {lesson.instructions || intl.formatMessage(messages.translate)}
        </p>
        <LessonMediaContent lesson={lesson} />
        {
          answers.map((word, index) => (
            <div
              key={`${lesson.words[index].baseWord}${index}`}
              className={`lesson-word item-box ${correctClasses[word.correct] ? correctClasses[word.correct] : ''}`}
            >
              <TextInput
                disabled
                value={lesson.words[index].baseWord}
              />
              <TextInput
                value={word.userAnswer}
                disabled={showResult}
                onFocus={(e) => inputFocusHandler(e, lesson.id, index)}
                onChange={e => {
                  updateAnswers(lesson.id, index, e.target.value)
                  updateCursorIndex()
                }}
                autoComplete="off"
                autoCorrect="off"
                autocaPitalize="off"
                spellCheck="false"
              />
              {
                showResult &&
                <TextInput
                  className="points-input"
                  disabled
                  value={word.points}
                />
              }
            </div>
          ))
        }
        {
          showResult &&
          <p className="lesson-result">{intl.formatMessage(messages.points)}: {points}/{maxPoints}</p>
        }
      </div>
    )
  }
}

TranslationTest.defaultProps = {
  showResult: false,
  inputFocusHandler: null,
  updateCursorIndex: null,
  initAnswers: null,
  updateAnswers: null,
  setResult: null,
  points: 0,
  maxPoints: 0,
  lessonOrder: 0,
  answers: [],
}

TranslationTest.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object.isRequired,
  showResult: PropTypes.bool,
  points: PropTypes.number,
  maxPoints: PropTypes.number,
  lessonOrder: PropTypes.number,
  answers: PropTypes.array,
  inputFocusHandler: PropTypes.func,
  updateCursorIndex: PropTypes.func,
  initAnswers: PropTypes.func,
  updateAnswers: PropTypes.func,
  setResult: PropTypes.func,
}

const enhance = compose(
  connect((state) => ({
    exam: state.tests.exam,
  }),
  { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)

export default enhance(TranslationTest)

const messages = defineMessages({
  translate: {
    id: 'translationTest.translate',
    defaultMessage: 'Preložte nasledujúce výrazy/Odpovedzte na otázky:',
  },
  points: {
    id: 'translationTest.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/TranslationTest.js